import {
  Box,
  Divider,
  Grid,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat } from '../../../../helpers';
import { SnackbarAlertWidget } from '../../../../widgets';
import BlopedFechasView from '../../bloped_fechas/BlopedFechasView';
import {
  CustomTabPanel,
  a11yProps,
} from '../../materias/components/AsignarCarreras';

const PanelBloquesPedagogicosView = () => {
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const activo = bloquesPedagogicosStore.activo;

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Fechas de apertura"
        >
          <Tab label="Fechas de apertura" {...a11yProps(0)} />
          {/* <Tab label="Carreras" {...a11yProps(1)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} p={0} index={0}>
        <BlopedFechasView />
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={1}>
        
      </CustomTabPanel> */}
    </Box>
  );

  const text = (title, text) => (
    <Stack direction="row" spacing={1}>
      <Typography sx={{ fontWeight: 'bold' }}>{title}:</Typography>
      <Typography>{text}</Typography>
    </Stack>
  );

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={bloquesPedagogicosStore.alertView} />
      <Grid item md={4}>
        <Paper elevation={4} sx={{ p: 2 }}>
          <Typography variant="h5" align="center" sx={{ fontWeight: 'bold' }}>
            {activo.nombre}
          </Typography>
          {text(CONST.abrev.label, activo.abrev)}
          {text(CONST.numero.label, activo.numero)}
          {text(CONST.desc.label, activo.desc)}
          {text(CONST.estatus.label, activo.estatus.nombre)}
          <Divider textAlign="left" sx={{ my: 1 }}>
            Fecha activa
          </Divider>
          {text(
            CONST.periodoAcademico.label,
            `${activo.fechaActiva?.periodoAcademico.desde ?? '--'}-${
              activo.fechaActiva?.periodoAcademico.hasta ?? '--'
            } (${activo.fechaActiva?.periodoAcademico.nombre ?? '--'})`,
          )}
          {text(
            CONST.desde.label,
            activo.fechaActiva
              ? dateformat(activo.fechaActiva?.desde, { inverse: true })
              : '--',
          )}
          {text(
            CONST.hasta.label,
            activo.fechaActiva
              ? dateformat(activo.fechaActiva?.hasta, { inverse: true })
              : '--',
          )}
        </Paper>
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>{tabs}</Paper>
      </Grid>
    </Grid>
  );
};

export default PanelBloquesPedagogicosView;
